import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { setTransLatorData } from '@reducers/keyword/keywordTranslatorSlice';
import LoaderComponent from '@components/atom/layout/loader';
import FadeLoader from 'react-spinners/FadeLoader';

const ResultBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { translatorResult, translatorResultStatus } = useSelector(
    ({ keywordTranslator }: RootState) => keywordTranslator
  );

  const onChangeTranslator = useCallback(
    (event) => {
      const { name, value } = event.target;
      dispatch(
        setTransLatorData({
          name: name,
          value: value,
        })
      );
    },
    [dispatch, setTransLatorData]
  );

  return (
    <div className="tb-basic-wrap tb-type-2">
      <div className="tb-basic-inner">
        {translatorResult?.length > 0 && (
          <table>
            <colgroup>
              <col width="20%" />
              <col width="50%" />
              <col width="30%" />
            </colgroup>
            <thead>
              <tr>
                <th>Language</th>
                <th>Translated Keywords</th>
                <th>Keyword Spot Usage</th>
              </tr>
            </thead>
            <tbody>
              {translatorResult.map((item, index) => (
                <tr key={item.value}>
                  <td>
                    <div className="flag-country type-1">
                      <p className="flag-country-txt">{item.text}</p>
                      <div className="flag-svg">
                        <img
                          alt={item.text}
                          src={`http://purecatamphetamine.github.io/country-flag-icons/3x2/${item.value}.svg`}
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <textarea
                      name={item.value}
                      value={item.translatedText}
                      onChange={onChangeTranslator}
                      className="textarea textarea-type-2"
                    >
                      {/* {item.translatedKeywords} */}
                    </textarea>
                  </td>
                  <td>
                    <div className="rosetta-score type-1">
                      <div className="inner" style={{ width: `${item.translatedText.length}%` }}>
                        <span className="txt">{`${item.translatedText.length}/100 Characters`}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {translatorResultStatus === 'pending' && (
          <LoaderComponent height="590px">
            <FadeLoader />
          </LoaderComponent>
        )}
      </div>
    </div>
  );
};

export default ResultBox;
